import { createContext } from "react";

export const NavbarContext = createContext([false, ()=>{}]);